// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBZAqdIwiURCvqf6Z8U4xcyeang_c3GEwI',
    authDomain: 'youthplay10.firebaseapp.com',
    projectId: 'youthplay10',
    storageBucket: 'youthplay10.appspot.com',
    messagingSenderId: '285760642354',
    appId: '1:285760642354:web:57729b3acf935c75c3cb2b',
    measurementId: 'G-40RC4NM89E',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
